import { SearchOrganizations } from '@platform/client';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { CauseSelectionDropdown } from '../../components/CauseSelectionDropdown';
import { IndustrySelectionDropdown } from '../../components/IndustrySelectionDropdown';
import { MultipleCountrySelectionDropdown } from '../../components/MultipleCountrySelectionDropdown';
import { PaginationBar } from '../../components/PaginationBar';
import { OrganizationCard } from './OrganizationCard';

const OrganizationPageSize = 50;
export const OrganizationCards = () => {
  const [sdgSelection, setSdgSelection] = useState<string[]>([]);
  const [countrySelection, setCountrySelection] = useState<string[]>([]);
  const [industrySelection, setIndustrySelection] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const data = SearchOrganizations.useSearchOrganizations({
    causes: sdgSelection.join(';'),
    countries: countrySelection.join(';'),
    industries: industrySelection.join(';'),
    page: currentPage,
    limit: OrganizationPageSize,
  });

  const numOrganizations = data.data?.filteredCount || 0;
  const numPages = Math.ceil(numOrganizations / OrganizationPageSize);

  const onPageSelect = (page: number) => {
    setCurrentPage(page - 1);
  };

  return (
    <div>
      <div className='flex flex-col md:flex-row md:gap-4 text-lg p-2'>
        <CauseSelectionDropdown
          selectedCauses={sdgSelection}
          onCausesSelectionChange={setSdgSelection}
          label='What causes would you like to contribute to?'
        />
        <MultipleCountrySelectionDropdown
          selectedCountries={countrySelection}
          onCountriesSelectionChange={setCountrySelection}
          label='What locations are you interested in?'
        />
        <IndustrySelectionDropdown
          selectedIndustries={industrySelection}
          onIndustriesSelectionChange={setIndustrySelection}
          label='What industries are you interested in?'
        />
      </div>
      {data.isSuccess && (
        <div className='grid grid-cols-1 md:grid-cols-3 bg-gray-50 gap-6 py-10 px-4'>
          {data.data.organizations.map((organization) => {
            return <OrganizationCard organization={organization} key={organization.id} />;
          })}
        </div>
      )}
      {!data.isSuccess && <Skeleton />}
      <PaginationBar
        numPages={numPages}
        currentPage={currentPage + 1}
        onPageSelect={onPageSelect}
      />
    </div>
  );
};
